import { render } from "./message-edit.vue?vue&type=template&id=71fd6312&lang=pug"
import script from "./message-edit.vue?vue&type=script&setup=true&lang=js"
export * from "./message-edit.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__